import { render } from "./message-text-input.component.vue?vue&type=template&id=5cc858b6"
import script from "./message-text-input.component.vue?vue&type=script&lang=js"
export * from "./message-text-input.component.vue?vue&type=script&lang=js"

import "./message-text-input.component.vue?vue&type=style&index=0&id=5cc858b6&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__